import * as React from 'react'

import { cn } from '@/shared/lib/utils'

/**
 * Shell del footer fijo del side panel: queda pegado abajo (no scrollea con el contenido),
 * con borde superior y padding estándar. El contenido (p.ej. <SidePanelActions/>) se pasa
 * como children. Es un primitivo de layout, portable: sólo estilos + `cn` + passthrough.
 */
export const SidePanelFooter = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<'div'>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('bg-background shrink-0 border-t border-accent px-4 py-3', className)}
    {...props}
  />
))
SidePanelFooter.displayName = 'SidePanelFooter'
